import "core-js/modules/web.timers.js";
import { useEffect } from 'react';

/**
 * Hook to fire a function when the user clicks outside an HTML Element that is provided through a Ref.
 */
export function useClickOutside(ref, callback) {
  var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  /**
   * Adds the event listener on mount, and then removes the listener on unmount.
   */
  useEffect(function () {
    /**
     * Function to fire when the user clicks
     */
    var handleClick = function handleClick(event) {
      if (ref && !ref.contains(event.target)) {
        callback(event);
      }
    };
    // Returning nothing prevents us from adding an event listener _and_ avoids unnecessary cleanup.
    if (!active || !ref) return;
    // This hook may be used in a component that's rendered on click. To prevent our click listener
    // from receiving that initial click, we use a setTimeout.
    // More info: https://github.com/facebook/react/issues/24657#issuecomment-1150119055
    setTimeout(function () {
      return document.addEventListener('click', handleClick);
    });
    return function () {
      // Using setTimeout here to ensure that removeEventListener always runs after addEventListener.
      setTimeout(function () {
        return document.removeEventListener('click', handleClick);
      });
    };
  }, [active, callback, ref]);
}